import { render, staticRenderFns } from "./RequestImport.vue?vue&type=template&id=8d9134c2&"
import script from "./RequestImport.vue?vue&type=script&lang=js&"
export * from "./RequestImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports